import { ReactComponent as FlowersSvg2Svg } from '@assets/svgs/whimsical.svg';
import { AnimatedVector, FaqAccordion, GridContainer } from '@components';
import { FAQ_ITEMS } from '@constants/faqItems';
import { useNavigationVisibility } from '@hooks';
import { Navigation } from '@modules';
import { useTranslation } from '@i18n';
import { FaqSideStars } from './FaqSideStars';

export const FaqPage = () => {
  const { t } = useTranslation();
  const showNavigation = useNavigationVisibility({ visibleAtTop: true });

  return (
    <main className="relative overflow-hidden bg-blood-orange text-cream">
      <FaqSideStars />
      <div className="relative z-10">
        <Navigation isVisible={showNavigation} />
        <GridContainer className="py-32 md:py-28">
          <div className="col-span-4 md:col-span-6 lg:col-span-6 lg:col-start-4">
            <h1 className="text-style-cursive-title text-xl text-center text-cream lg:text-4xl">
              {t('faq.title')}
            </h1>
            <div className="w-full max-w-xs mx-auto">
              <AnimatedVector
                Svg={FlowersSvg2Svg}
                className="w-full"
                svgClassName="block h-auto w-full text-cream"
                animationOptions={{
                  intensity: 'medium',
                  effect: 'stroke',
                }}
              />
            </div>
            <FaqAccordion items={FAQ_ITEMS} />
          </div>
        </GridContainer>
      </div>
    </main>
  );
};
